module.exports = __webpack_public_path__ + "img/game3.540da224.jpg";